import {type AxiosResponse} from "axios";
import {versionEndpoint} from "./endpoints";
import {get} from "../../infrastructure/api";
import {type VersionDto} from "./types";
import {type ApiResponse} from "../../infrastructure/types";

export const getVersion = async (): Promise<AxiosResponse<ApiResponse<VersionDto>>> =>
  await get({endpoint: versionEndpoint});
